import styled from 'styled-components/macro';
import { Button } from '@material-ui/core';
import { ButtonBackgroundColorByCurrentApp, ButtonHoverBackgroundColorByCurrentApp, ButtonActiveBackgroundColorByCurrentApp, BorderButtonByCurrentApp, BorderButtonHoverByCurrentApp, BorderButtonActiveByCurrentApp } from '../../utils/get-app-env';

type ButtonProps = {
  typecolor: 'blueButton' | 'exitButton';
};

export const StyledButton = styled(Button)<ButtonProps>`
  && {
    background-color: ${(ButtonBackgroundColorByCurrentApp())};
    border-bottom: ${(BorderButtonByCurrentApp())};
    color: #fff;
    ${({ disabled }) => disabled && 'border-bottom : '+(BorderButtonByCurrentApp())+';'}

    :hover {
      background-color: ${(ButtonHoverBackgroundColorByCurrentApp())};
      border-bottom: ${(BorderButtonHoverByCurrentApp())};
    }
    :active {
      background-color: ${(ButtonActiveBackgroundColorByCurrentApp())};
      border-bottom: ${(BorderButtonActiveByCurrentApp())};;
    }
  }
`;

export const OutlinedButton = styled(Button)<ButtonProps>`
  && {
    color: #a2a7ac;

    ${({ disabled }) =>
      disabled &&
      'background-color: #FFFFFF; color: #A2A7AC; border: #A2A7AC 1px solid'}

    :hover {
      color: #f45248;
      border: #f45248 1px solid;
      background-color: #fff;
    }
  }
`;
